import AccountBalanceIcon from '@/assets/time-off-icons/account_balance.inline.svg'
import AccountBalanceWalletIcon from '@/assets/time-off-icons/account_balance_wallet.inline.svg'
import AccountCircleIcon from '@/assets/time-off-icons/account_circle.inline.svg'
import AddAlertIcon from '@/assets/time-off-icons/add_alert.inline.svg'
import AirlineSeatIndividualSuiteIcon from '@/assets/time-off-icons/airline_seat_individual_suite.inline.svg'
import AirplanemodeActiveIcon from '@/assets/time-off-icons/airplanemode_active.inline.svg'
import AirportShuttleIcon from '@/assets/time-off-icons/airport_shuttle.inline.svg'
import BatteryChargingFullIcon from '@/assets/time-off-icons/battery_charging_full.inline.svg'
import BusinessCenterIcon from '@/assets/time-off-icons/business_center.inline.svg'
import EcgHeartIcon from '@/assets/time-off-icons/ecg_heart.inline.svg'
import EnhancedEncryptionIcon from '@/assets/time-off-icons/enhanced_encryption.inline.svg'
import EventIcon from '@/assets/time-off-icons/event.inline.svg'
import EventSeatIcon from '@/assets/time-off-icons/event_seat.inline.svg'
import FavoriteIcon from '@/assets/time-off-icons/favorite.inline.svg'
import HealthAndSafetyIcon from '@/assets/time-off-icons/health_and_safety.inline.svg'
import HeartIcon from '@/assets/time-off-icons/heart.inline.svg'
import HomeIcon from '@/assets/time-off-icons/home.inline.svg'
import HomeHeartFilledIcon from '@/assets/time-off-icons/home_heart_filled.inline.svg'
import MonetizationIcon from '@/assets/time-off-icons/monetization.inline.svg'
import PaymentIcon from '@/assets/time-off-icons/payment.inline.svg'
import PermContactCalendarIcon from '@/assets/time-off-icons/perm_contact_calendar.inline.svg'
import ReportProblemIcon from '@/assets/time-off-icons/report_problem.inline.svg'
import SupervisorAccountIcon from '@/assets/time-off-icons/supervisor_account.inline.svg'
import TravelLuggageIcon from '@/assets/time-off-icons/travel_luggage.inline.svg'
import TreePalmIcon from '@/assets/time-off-icons/tree_palm.inline.svg'

export {
  AccountBalanceIcon,
  AccountBalanceWalletIcon,
  AccountCircleIcon,
  AddAlertIcon,
  AirlineSeatIndividualSuiteIcon,
  AirplanemodeActiveIcon,
  AirportShuttleIcon,
  BatteryChargingFullIcon,
  BusinessCenterIcon,
  EcgHeartIcon,
  EnhancedEncryptionIcon,
  EventIcon,
  EventSeatIcon,
  FavoriteIcon,
  HealthAndSafetyIcon,
  HeartIcon,
  HomeIcon,
  HomeHeartFilledIcon,
  MonetizationIcon,
  PaymentIcon,
  PermContactCalendarIcon,
  ReportProblemIcon,
  SupervisorAccountIcon,
  TravelLuggageIcon,
  TreePalmIcon
}
